import {
  ILargeCardProps,
  LargeCard,
} from "@/pages/dashboard/stats/subs/LargeCard";
import { ReportWrapper } from "../../style";
import {
  auditTrailTableHeader,
  auditTrailTableKey,
  expiredDrugReportTableHeader,
  expiredDrugReportTableKey,
  financialReportTableHeader,
  financialReportTableKey,
  getAuditTrailTableData,
  getExpiredDrugReportTableData,
  getFinancialReportTableData,
  getStockLevelTableData,
  hospitalHeadFinancialCards,
  stockeLevelTableKey,
  stockLevelReportTableHeaders,
} from "../data";
import Table from "@/common/components/Table";
import { Pagination } from "@/common/components/pagination";
import useQuery from "@/hooks/useQuery";
import { DELIVERY_REQUEST_URLS } from "@/common/constants";
import { useCallback, useMemo, useState } from "react";
import { KeyValueObj } from "@/common/types";
import Tab2 from "@/common/components/Tab/Tab2";
import { Button } from "@/common/components/button";
import { Select } from "@/common/components/selectInput";

const HospitalHeadReport = () => {
  const [stockLevelPerPage, setStockLevelPerPage] = useState(10);
  const [expiredDrugPerPage, setExpiredDrugPerPage] = useState(10);
  const [financialPerPage, setFinancialPerPage] = useState(10);
  const [auditTrailPerPage, setAuditTrailPerPage] = useState(10);
  const [showStockLevelDropdown, setShowStockLevelDropdown] = useState(false);
  const [showExpiredDrugDropdown, setShowExpiredDrugDropdown] = useState(false);
  const [showFinancialReportDropdown, setShowFinancialReportDropdown] =
    useState(false);
  const [showAuditTrailDropdown, setShowAuditTrailDropdown] = useState(false);
  const [stockLevelRow, setStockLevelRow] = useState<KeyValueObj>({});
  const [expiredDrugRow, setExpiredDrugRow] = useState<KeyValueObj>({});
  const [financialReportRow, setFinancialReportRow] = useState<KeyValueObj>({});
  const [auditTrailRow, setAuditTrailRow] = useState<KeyValueObj>({});
  const [currentTab, setCurrentTab] = useState("Stock Level Report");

  const {
    data: stockLevelData,
    meta: stockLevelMeta,
    loading: stockLevelLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${stockLevelPerPage}&page=${stockLevelPerPage}`
  );

  const {
    data: expiredDrugData,
    meta: expiredDrugMeta,
    loading: expiredDrugLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${expiredDrugPerPage}&page=${expiredDrugPerPage}`
  );

  const {
    data: financialReportData,
    meta: financialReportMeta,
    loading: financialReportLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${financialPerPage}&page=${financialPerPage}`
  );

  const {
    data: auditTrailData,
    meta: auditTrailMeta,
    loading: auditTrailLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${auditTrailPerPage}&page=${auditTrailPerPage}`
  );

  const handleStockLevelView = useCallback(() => {
    alert("comming soon");
  }, []);

  const handleExpiredDrugView = useCallback(() => {
    alert("comming soon");
  }, []);

  const handleFinancialReportView = useCallback(() => {
    alert("comming soon");
  }, []);

  const handleAuditTrailView = useCallback(() => {
    alert("comming soon");
  }, []);

  const stockLevelDropdownOptions = useMemo(
    () =>
      stockLevelRow?.trackingID?.value !== "--"
        ? [{ label: "View", action: handleStockLevelView }]
        : [{ label: "View", action: handleStockLevelView }],
    [handleStockLevelView, stockLevelRow]
  );

  const expiredDrugDropdownOptions = useMemo(
    () =>
      expiredDrugRow?.trackingID?.value !== "--"
        ? [{ label: "View", action: handleExpiredDrugView }]
        : [{ label: "View", action: handleExpiredDrugView }],
    [handleExpiredDrugView, expiredDrugRow]
  );

  const financialReportDropdownOptions = useMemo(
    () =>
      financialReportRow?.trackingID?.value !== "--"
        ? [{ label: "View", action: handleFinancialReportView }]
        : [{ label: "View", action: handleFinancialReportView }],
    [handleFinancialReportView, financialReportRow]
  );

  const auditTrailDropdownOptions = useMemo(
    () =>
      auditTrailRow?.trackingID?.value !== "--"
        ? [{ label: "View", action: handleAuditTrailView }]
        : [{ label: "View", action: handleAuditTrailView }],
    [handleAuditTrailView, auditTrailRow]
  );

  const handleStockLevelDropdownClick = useCallback(
    (row: KeyValueObj) => {
      const willShow = !showStockLevelDropdown;
      const newRow = willShow ? row : {};

      setStockLevelRow(newRow);
      setShowStockLevelDropdown(willShow);
    },
    [showStockLevelDropdown]
  );

  const handleExpiredDrugDropdownClick = useCallback(
    (row: KeyValueObj) => {
      const willShow = !showExpiredDrugDropdown;
      const newRow = willShow ? row : {};

      setExpiredDrugRow(newRow);
      setShowExpiredDrugDropdown(willShow);
    },
    [showExpiredDrugDropdown]
  );

  const handleFinancialReportDropdownClick = useCallback(
    (row: KeyValueObj) => {
      const willShow = !showFinancialReportDropdown;
      const newRow = willShow ? row : {};

      setFinancialReportRow(newRow);
      setShowFinancialReportDropdown(willShow);
    },
    [showFinancialReportDropdown]
  );

  const handleAuditTrailDropdownClick = useCallback(
    (row: KeyValueObj) => {
      const willShow = !showAuditTrailDropdown;
      const newRow = willShow ? row : {};

      setAuditTrailRow(newRow);
      setShowAuditTrailDropdown(willShow);
    },
    [showAuditTrailDropdown]
  );

  const tabs = [
    {
      title: "Stock Level Report",
      component: (
        <div className="table-wrapper">
          <Table
            tableHeaders={stockLevelReportTableHeaders}
            tableKeys={stockeLevelTableKey}
            tableData={getStockLevelTableData()}
            tableTitle="Stock Level Report"
            tableSubtitle={(stockLevelMeta?.total_count ?? "0") + " Requests"}
            loading={stockLevelLoading}
            handleDropDownClicked={handleStockLevelDropdownClick}
            showDropDown={showStockLevelDropdown}
            dropDownOptions={stockLevelDropdownOptions}
            spaced
            rowLineColor="light"
          />
          <Pagination
            pageCount={stockLevelData?.total_pages}
            onNextPage={(event: KeyValueObj) =>
              setStockLevelPerPage(event.selected)
            }
            onPerPageChange={(event: KeyValueObj) =>
              setStockLevelPerPage(event?.target?.value)
            }
          />
        </div>
      ),
    },
    {
      title: "Expired Drugs Report",
      component: (
        <div className="table-wrapper">
          <Table
            tableHeaders={expiredDrugReportTableHeader}
            tableKeys={expiredDrugReportTableKey}
            tableData={getExpiredDrugReportTableData(expiredDrugData)}
            tableTitle="Expired Drugs Data"
            loading={expiredDrugLoading}
            handleDropDownClicked={handleExpiredDrugDropdownClick}
            showDropDown={showExpiredDrugDropdown}
            dropDownOptions={expiredDrugDropdownOptions}
            spaced
            rowLineColor="light"
          />
          <Pagination
            pageCount={expiredDrugMeta?.total_pages}
            onNextPage={(event: KeyValueObj) =>
              setExpiredDrugPerPage(event.selected)
            }
            onPerPageChange={(event: KeyValueObj) =>
              setExpiredDrugPerPage(event?.target?.value)
            }
          />
        </div>
      ),
    },
    {
      title: "Financial Report",
      component: (
        <div className="table-wrapper">
          <Table
            tableHeaders={financialReportTableHeader}
            tableKeys={financialReportTableKey}
            tableData={getFinancialReportTableData(financialReportData)}
            tableTitle="Financial Report"
            loading={financialReportLoading}
            handleDropDownClicked={handleFinancialReportDropdownClick}
            showDropDown={showFinancialReportDropdown}
            dropDownOptions={financialReportDropdownOptions}
            spaced
            rowLineColor="light"
          />
          <Pagination
            pageCount={financialReportMeta?.total_pages}
            onNextPage={(event: KeyValueObj) =>
              setFinancialPerPage(event.selected)
            }
            onPerPageChange={(event: KeyValueObj) =>
              setFinancialPerPage(event?.target?.value)
            }
          />
        </div>
      ),
    },
    {
      title: "Audit Trail",
      component: (
        <div className="table-wrapper">
          <Table
            tableHeaders={auditTrailTableHeader}
            tableKeys={auditTrailTableKey}
            tableData={getAuditTrailTableData(auditTrailData)}
            tableTitle="Audit Trail Data"
            loading={auditTrailLoading}
            handleDropDownClicked={handleAuditTrailDropdownClick}
            showDropDown={showAuditTrailDropdown}
            dropDownOptions={auditTrailDropdownOptions}
            spaced
            rowLineColor="light"
          />
          <Pagination
            pageCount={auditTrailMeta?.total_pages}
            onNextPage={(event: KeyValueObj) =>
              setAuditTrailPerPage(event.selected)
            }
            onPerPageChange={(event: KeyValueObj) =>
              setAuditTrailPerPage(event?.target?.value)
            }
          />
        </div>
      ),
    },
  ];
  return (
    <ReportWrapper>
      <div className="card-wrapper">
        {hospitalHeadFinancialCards(stockLevelData).map(
          (card: ILargeCardProps) => (
            <LargeCard
              color={card?.color}
              icon={card.icon}
              value={card.value}
              title={card.title}
            />
          )
        )}
      </div>
      {/* export data */}
      <div className="export-wrapper">
        <div className="select-wrapper">
          {currentTab === "Audit Trail" && (
            <Select
              name="Sort"
              formValues={[]}
              shortWidth
              fullWidth={false}
              placeholder="Sort By"
              prompt=""
              indexLevel={0}
              setFormValues={() => {}}
              options={[
                {
                  title: "2025",
                  value: "2025",
                },
                {
                  title: "2024",
                  value: "2024",
                },
              ]}
            />
          )}
        </div>
        <Button>Export</Button>
      </div>
      <Tab2
        onTabClick={(tab: string) => setCurrentTab(tab)}
        currentTab={currentTab}
        tabs={tabs}
      />
    </ReportWrapper>
  );
};

export default HospitalHeadReport;
